export default __webpack_public_path__ + "alberta-fab-download.9fb1927e3bc90c133054.svg";